module.exports = __webpack_public_path__ + "img/mytarget-app.2796bf79.svg";